module.exports = __webpack_public_path__ + "img/dep_fishandseafood@3x.578fa1d9.png";